import { IconButton } from "@material-ui/core"
import { useDispatch } from "react-redux"
import CloudDownloadTwoTone from "@material-ui/icons/CloudDownloadTwoTone"
import { obtenerEstadoCuentaDevolucionAction } from "../../../ducks/devolucionesDuck"
import { useState } from "react"
import { ToastMessage } from "../../../global/ToastMessage"
import BackDrop from "../../../global/BackDrop"
const ButtonDowloadEstadoCueta = (props) => {
    const { IdDevolucionSolicitud } = props
    const dispatch = useDispatch()
    const [load, setLoad] = useState(false)
    const onDowload = () => {
        setLoad(true)
        dispatch(obtenerEstadoCuentaDevolucionAction({ IdDevolucionSolicitud: IdDevolucionSolicitud })).then(Response => {
            if (Response.status || Response?.status === 500) {
                ToastMessage.fire({
                    icon: "warning",
                    title: "Se produjo un error inesperado. Inténtelo de nuevo más tarde",
                });
                setLoad(false)
                return null
            }

            const downloadUrl = window.URL.createObjectURL(new Blob([Response.data], { type: Response.contentType }));
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.target = "_blank"
            // let fchAct = new Date().toISOString();
            // let fileName =  `${"EDC"} - ${fchAct}.pdf`;
            // link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setLoad(false)
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    return (
        <div>
            <IconButton aria-label="Descargar" onClick={onDowload} >
                <CloudDownloadTwoTone color="primary" />
            </IconButton>
            <BackDrop open={load} />
        </div>

    )
}
export default ButtonDowloadEstadoCueta